import { graphql, HttpResponse } from 'msw'
import { type EnrollmentInvestmentGoalsData, type EnrollmentInvestmentGoalsSubmitOutput } from '../../../models'

export const getEnrollmentInvestmentGoalsDataMock: EnrollmentInvestmentGoalsData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/investment-goals',
  enrollmentData: {
    userInfo: {
      investment: {
        experience: 'VERY_LITTLE',
        objective: 'GENERATE_INCOME',
      },
    },
  },
}

export const submitEnrollmentInvestmentGoalsDataMock: EnrollmentInvestmentGoalsSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/loading',
  enrollmentData: {
    userInfo: {
      investment: {
        experience: 'VERY_LITTLE',
        objective: 'GENERATE_INCOME',
      },
    },
  },
}

export const mockGetEnrollmentInvestmentGoalsData = graphql.mutation('getEnrollmentInvestmentGoalsData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentInvestmentGoalsDataMock } })
})

export const mockSubmitEnrollmentInvestmentGoalsData = graphql.mutation('submitEnrollmentInvestmentGoalsData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentInvestmentGoalsDataMock } })
})

export const mockEnrollmentInvestmentGoals = [
  mockGetEnrollmentInvestmentGoalsData,
  mockSubmitEnrollmentInvestmentGoalsData,
]
